import { defineComponent as _defineComponent } from 'vue'
import LfGridComponent from '@/components/grids/LfGrid/LfGridComponent.vue'
import { ActionName, CommandClickEventArgs } from '@/components/grids/LfGrid/LfGridTypes'
import { computed } from 'vue'
import { Icons } from '@/icons/icons'
import { ToolbarItemModel } from '@syncfusion/ej2-vue-filemanager'
import { ClickEventArgs } from '@syncfusion/ej2-vue-navigations'
import {
  commandColumnConfigurationPanel
} from '@/views/ConfigurationPanel/types/configurationPanelTypes'
import useGridConfiguration from '@/composables/useGridConfiguration'
import { ContextMenuClickEventArgs, ContextMenuItemModel, RecordClickEventArgs } from '@syncfusion/ej2-vue-grids'
import { useI18n } from 'vue-i18n-composable'
import {
  kebakMenuToolbarItem,
  searchToolbarItem
} from '@/components/grids/LfGrid/components/ToolbarContextMenu/ToolbarContextMenuType'
import NumerationTitleComponent from './NumerationTitleComponent.vue'
import useNumeration from './composables/useNumeration'


export default /*#__PURE__*/_defineComponent({
  __name: 'NumerationGridComponent',
  emits: [
  'row-click',
  'command-click',
  'toolbar-click',
  'context-menu-click'
],
  setup(__props, { emit }) {

const { t } = useI18n()

// DEFINE CONST  ======================================================================================================
const texts = {
  title: 'Numeración automática',
  buttons: {
    new: t('action_buttons.new_numeration').toString()
  }
}

// COMPOSABLES   ======================================================================================================
const { gridConfiguration } = useGridConfiguration({
  listName: 'listManNumeration',
  context: 'configurationPanelAutomaticNumbering',
  commandButtons: commandColumnConfigurationPanel
})

const { numerationList, read } = useNumeration()

// COMPUTEDS ==========================================================================================================
const toolbarItemsOptions = computed((): ToolbarItemModel[] => {
  return [
      searchToolbarItem,
      {
        id: ActionName.ADD,
        text: texts.buttons.new,
        align: 'Right',
        tooltipText: texts.buttons.new,
        cssClass: 'lf-btn-model2'
      },
      kebakMenuToolbarItem
    ]
})

const contextMenuItems = computed((): ContextMenuItemModel[] => {
  return [
  {
      id: ActionName.EDIT,
      text: t('components.context_menu.edit').toString(),
      iconCss: Icons.EDIT
    },
    {
      id: ActionName.REMOVE,
      text: t('components.context_menu.remove').toString(),
      iconCss: Icons.REMOVE
    }
  ]
})

// EVENTS =============================================================================================================


const onToolbarClick = ({ item }: ClickEventArgs) => {
  emit('toolbar-click', item)
}


const onRowClick = ({ rowData }: RecordClickEventArgs) => {
  emit('row-click', rowData)
}

const onCommandClick = ({ rowData }: CommandClickEventArgs) => {
  emit('command-click', rowData)
}

const onContextMenuClicked = ({ rowInfo, item }: ContextMenuClickEventArgs) => {
  emit('context-menu-click', item, rowInfo)
}

async function init() {
  read()
}

// HOOKS =============================================================================================================
init()

return { __sfc: true,t, texts, gridConfiguration, numerationList, read, toolbarItemsOptions, contextMenuItems, emit, onToolbarClick, onRowClick, onCommandClick, onContextMenuClicked, init, LfGridComponent, NumerationTitleComponent }
}

})